import React from 'react'

const ViewMeeting = () => {
  return (
    <div>
      view meeting
    </div>
  )
}

export default ViewMeeting
